import { ALIAS, SERVICE_ALIAS, SEARCH_PARAMS, SERVER_TYPE, GAME_NAME, COMMUNITY_SERVER_TYPE } from './index';

const SORT_TYPE = {
  SCORE: '_score,desc',
  LEVEL: 'level,desc',
  ABYSS_POINT: 'abyss_point,desc',
  PHYSICAL: 'physical,desc',
  HP: 'hp,desc',
  MEMBER_COUNT: 'member_count,desc',
  POINT: 'point,desc',
  CREATED_DATETIME: 'created_datetime,desc',
};

const FIELD_TYPE = {
  TITLE: 'title',
  CONTENTS: 'contents',
  WRITER: 'writer',
  HASH: 'hash',
  GUIDE_NAME: 'guide_name',
  CONTENT: 'content',
  TAGS: 'tags',
  SUBJECT: 'subject',
  TAG: 'tag',
  CHARACTER: 'character',
  JOB: 'job',
  ITEM: 'item',
  QUEST: 'quest',
  ZONE: 'zone',
  BOSS: 'boss',
  GAME_DATA: 'game_data',
};

export const FILTER_LINEAGE = {
  [ALIAS.COMMUNITY]: {
    [SEARCH_PARAMS.BOARD_ALIAS]: [{ l10nKey: 'boardAll', value: '' }],
    [SEARCH_PARAMS.SEARCH_TYPE]: [
      { l10nKey: 'all', value: [FIELD_TYPE.TITLE, FIELD_TYPE.CONTENT, FIELD_TYPE.WRITER].join(',') },
      { l10nKey: 'titlePlusContent', value: [FIELD_TYPE.TITLE, FIELD_TYPE.CONTENTS].join(',') },
      { l10nKey: 'title', value: FIELD_TYPE.TITLE },
      { l10nKey: 'writer', value: FIELD_TYPE.WRITER },
    ],
  },
};

export const FILTER_LINEAGE2 = {
  [ALIAS.GUIDEBOOK]: {
    [SEARCH_PARAMS.GAME_NAME]: [
      { l10nKey: 'l2Server', value: GAME_NAME[SERVICE_ALIAS.LINEAGE2].L2 },
      { l10nKey: 'l2AwknServer', value: GAME_NAME[SERVICE_ALIAS.LINEAGE2].L2AWKN },
    ],
    [SEARCH_PARAMS.FIELD]: [
      { l10nKey: 'all', value: '' },
      { l10nKey: 'titlePlusContent', value: [FIELD_TYPE.GUIDE_NAME, FIELD_TYPE.CONTENT].join(',') },
      { l10nKey: 'title', value: FIELD_TYPE.GUIDE_NAME },
      { l10nKey: 'tag', value: FIELD_TYPE.TAGS },
    ],
  },
  [ALIAS.DICTIONARY]: {
    [SEARCH_PARAMS.SERVER]: [
      { l10nKey: 'l2Server', value: SERVER_TYPE[SERVICE_ALIAS.LINEAGE2].L2 },
      { l10nKey: 'l2AwknServer', value: SERVER_TYPE[SERVICE_ALIAS.LINEAGE2].L2AWKN },
    ],
    [SEARCH_PARAMS.SERVICE]: [
      { l10nKey: 'dictionaryAll', value: '' },
      { l10nKey: 'itemDictionary', value: 'item' },
      { l10nKey: 'skillDictionary', value: 'skill' },
    ],
    [SEARCH_PARAMS.SORT]: [
      { l10nKey: 'scoreDesc', value: 'rank' },
      { l10nKey: 'nameDesc', value: 'name,asc' },
    ],
  },
  [ALIAS.COMMUNITY]: {
    [SEARCH_PARAMS.SERVER]: [
      { l10nKey: 'l2Server', value: COMMUNITY_SERVER_TYPE[SERVICE_ALIAS.LINEAGE2].L2 },
      { l10nKey: 'l2AwknServer', value: COMMUNITY_SERVER_TYPE[SERVICE_ALIAS.LINEAGE2].L2AWKN },
    ],
    [SEARCH_PARAMS.BOARD_ALIAS]: [{ l10nKey: 'boardAll', value: '' }],
    [SEARCH_PARAMS.SEARCH_TYPE]: [
      { l10nKey: 'all', value: [FIELD_TYPE.TITLE, FIELD_TYPE.CONTENT, FIELD_TYPE.WRITER].join(',') },
      { l10nKey: 'titlePlusContent', value: [FIELD_TYPE.TITLE, FIELD_TYPE.CONTENTS].join(',') },
      { l10nKey: 'title', value: FIELD_TYPE.TITLE },
      { l10nKey: 'writer', value: FIELD_TYPE.WRITER },
    ],
  },
  [ALIAS.TAG]: {
    [SEARCH_PARAMS.SERVER]: [
      { l10nKey: 'l2Server', value: COMMUNITY_SERVER_TYPE[SERVICE_ALIAS.LINEAGE2].L2 },
      { l10nKey: 'l2AwknServer', value: COMMUNITY_SERVER_TYPE[SERVICE_ALIAS.LINEAGE2].L2AWKN },
    ],
  },
};

export const FILTER_BNS = {
  [ALIAS.COMMUNITY]: {
    [SEARCH_PARAMS.BOARD_ALIAS]: [{ l10nKey: 'boardAll', value: '' }],
    [SEARCH_PARAMS.SEARCH_TYPE]: [
      { l10nKey: 'all', value: [FIELD_TYPE.TITLE, FIELD_TYPE.CONTENT, FIELD_TYPE.WRITER].join(',') },
      { l10nKey: 'titlePlusContent', value: [FIELD_TYPE.TITLE, FIELD_TYPE.CONTENTS].join(',') },
      { l10nKey: 'title', value: FIELD_TYPE.TITLE },
      { l10nKey: 'writer', value: FIELD_TYPE.WRITER },
    ],
  },
  [ALIAS.GUIDEBOOK]: {
    [SEARCH_PARAMS.FIELD]: [
      { l10nKey: 'all', value: '' },
      { l10nKey: 'titlePlusContent', value: [FIELD_TYPE.GUIDE_NAME, FIELD_TYPE.CONTENT].join(',') },
      { l10nKey: 'title', value: FIELD_TYPE.GUIDE_NAME },
      { l10nKey: 'tag', value: FIELD_TYPE.TAGS },
    ],
  },
  [ALIAS.CHARACTER]: {
    [SEARCH_PARAMS.SERVER_ID]: [{ l10nKey: 'serverAll', value: '' }],
    [SEARCH_PARAMS.CLASS_ID]: [{ l10nKey: 'classAll', value: '' }],
    [SEARCH_PARAMS.SORT]: [
      { l10nKey: 'scoreDesc', value: SORT_TYPE.SCORE },
      { l10nKey: 'levelDesc', value: SORT_TYPE.LEVEL },
    ],
  },
  [ALIAS.GUILD]: {
    [SEARCH_PARAMS.SERVER_ID]: [{ l10nKey: 'serverAll', value: '' }],
    [SEARCH_PARAMS.SORT]: [
      { l10nKey: 'scoreDesc', value: SORT_TYPE.SCORE },
      { l10nKey: 'levelDesc', value: SORT_TYPE.LEVEL },
      { l10nKey: 'memberCountDesc', value: SORT_TYPE.MEMBER_COUNT },
    ],
  },
  [ALIAS.VIDEO]: {
    [SEARCH_PARAMS.SORT]: [
      { l10nKey: 'scoreDesc', value: SORT_TYPE.SCORE },
      { l10nKey: 'createdDatetimeDesc', value: SORT_TYPE.CREATED_DATETIME },
    ],
  },
};

export const FILTER_AION = {
  [ALIAS.GUIDEBOOK]: {
    [SEARCH_PARAMS.GAME_NAME]: [
      { l10nKey: 'aionLiveServer', value: GAME_NAME[SERVICE_ALIAS.AION].LIVE },
      { l10nKey: 'aionClassicServer', value: GAME_NAME[SERVICE_ALIAS.AION].CLASSIC },
      { l10nKey: 'common', value: 'common' },
    ],
    [SEARCH_PARAMS.FIELD]: [
      //{l10nKey: 'all', value: ''},
      { l10nKey: 'titlePlusContent', value: [FIELD_TYPE.GUIDE_NAME, FIELD_TYPE.CONTENT].join(',') },
      { l10nKey: 'title', value: FIELD_TYPE.GUIDE_NAME },
      { l10nKey: 'tag', value: FIELD_TYPE.TAGS },
    ],
  },
  [ALIAS.COMMUNITY]: {
    [SEARCH_PARAMS.BOARD_ALIAS]: [{ l10nKey: 'boardAll', value: '' }],
    [SEARCH_PARAMS.SEARCH_TYPE]: [
      { l10nKey: 'all', value: [FIELD_TYPE.TITLE, FIELD_TYPE.CONTENT, FIELD_TYPE.WRITER].join(',') },
      { l10nKey: 'titlePlusContent', value: [FIELD_TYPE.TITLE, FIELD_TYPE.CONTENTS].join(',') },
      { l10nKey: 'title', value: FIELD_TYPE.TITLE },
      { l10nKey: 'writer', value: FIELD_TYPE.WRITER },
    ],
  },
  [ALIAS.CHARACTER]: {
    [SEARCH_PARAMS.SERVER_ID]: [{ l10nKey: 'serverAll', value: '' }],
    [SEARCH_PARAMS.RACE_ID]: [
      { l10nKey: 'raceAll', value: '' },
      { l10nKey: 'elyos', value: '0' },
      { l10nKey: 'asmodian', value: '1' },
    ],
    [SEARCH_PARAMS.CLASS_ID]: [{ l10nKey: 'classAll', value: '' }],
    [SEARCH_PARAMS.SORT]: [
      { l10nKey: 'scoreDesc', value: SORT_TYPE.SCORE },
      { l10nKey: 'levelDesc', value: SORT_TYPE.LEVEL },
      { l10nKey: 'abyssPointDesc', value: SORT_TYPE.ABYSS_POINT },
      { l10nKey: 'physicalDesc', value: SORT_TYPE.PHYSICAL },
      { l10nKey: 'hpDesc', value: SORT_TYPE.HP },
    ],
  },
  [ALIAS.LEGION]: {
    [SEARCH_PARAMS.SERVER_ID]: [{ l10nKey: 'serverAll', value: '' }],
    [SEARCH_PARAMS.RACE_ID]: [
      { l10nKey: 'raceAll', value: '' },
      { l10nKey: 'elyos', value: '0' },
      { l10nKey: 'asmodian', value: '1' },
    ],
    [SEARCH_PARAMS.SORT]: [
      { l10nKey: 'scoreDesc', value: SORT_TYPE.SCORE },
      { l10nKey: 'memberCountDesc', value: SORT_TYPE.MEMBER_COUNT },
      { l10nKey: 'pointDesc', value: SORT_TYPE.POINT },
    ],
  },
  [ALIAS.VIDEO]: {
    [SEARCH_PARAMS.SORT]: [
      { l10nKey: 'scoreDesc', value: SORT_TYPE.SCORE },
      { l10nKey: 'createdDatetimeDesc', value: SORT_TYPE.CREATED_DATETIME },
    ],
  },
};

export const FILTER_LINEAGEM = {
  [ALIAS.GUIDEBOOK]: {
    [SEARCH_PARAMS.FIELD]: [
      { l10nKey: 'all', value: '' },
      { l10nKey: 'titlePlusContent', value: [FIELD_TYPE.GUIDE_NAME, FIELD_TYPE.CONTENT].join(',') },
      { l10nKey: 'title', value: FIELD_TYPE.GUIDE_NAME },
      { l10nKey: 'tag', value: FIELD_TYPE.TAGS },
    ],
  },
  [ALIAS.COMMUNITY]: {
    [SEARCH_PARAMS.BOARD_ALIAS]: [{ l10nKey: 'boardAll', value: '' }],
    [SEARCH_PARAMS.SEARCH_TYPE]: [
      { l10nKey: 'all', value: [FIELD_TYPE.TITLE, FIELD_TYPE.CONTENT, FIELD_TYPE.WRITER].join(',') },
      { l10nKey: 'titlePlusContent', value: [FIELD_TYPE.TITLE, FIELD_TYPE.CONTENTS].join(',') },
      { l10nKey: 'title', value: FIELD_TYPE.TITLE },
      { l10nKey: 'writer', value: FIELD_TYPE.WRITER },
    ],
  },
  [ALIAS.IMAGE]: {
    [SEARCH_PARAMS.SEARCH_TYPE]: [
      { l10nKey: 'all', value: '' },
      { l10nKey: 'titlePlusContent', value: [FIELD_TYPE.TITLE, FIELD_TYPE.CONTENTS].join(',') },
      { l10nKey: 'title', value: FIELD_TYPE.TITLE },
    ],
  },
};

export const FILTER_DATA = {
  [SERVICE_ALIAS.LINEAGE]: FILTER_LINEAGE,
  [SERVICE_ALIAS.LINEAGE2]: FILTER_LINEAGE2,
  [SERVICE_ALIAS.BNS]: FILTER_BNS,
  [SERVICE_ALIAS.AION]: FILTER_AION,
  [SERVICE_ALIAS.LINEAGEM]: FILTER_LINEAGEM,
};
